// extracted by mini-css-extract-plugin
export default {"base":"styles_base__B+FOG","bankid-mobile":"styles_bankid-mobile__PuD6l","status-message":"styles_status-message__aNFMv","padding":"styles_padding__Xb6Mv"};